import { useState } from 'react';
import { useDebounce } from '@/hooks/useDebounce';
import type { FilterState } from '@/types/filterTypes';
import { DEFAULT_FILTER_STATE } from '@/types/filterTypes';

export const useAdminFilters = (initialPosition?: string) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [behavioralFiltersExpanded, setBehavioralFiltersExpanded] = useState(false);
  const [profileFilter, setProfileFilter] = useState('all');
  const [currentFilters, setCurrentFilters] = useState<FilterState>({
    ...DEFAULT_FILTER_STATE,
    position: initialPosition || 'all',
  });
  
  const debouncedSearchTerm = useDebounce(searchTerm, 300);
  
  // Detect when search is "in progress" (user typing, waiting for debounce)
  const isSearching = searchTerm !== debouncedSearchTerm && searchTerm.length > 0;

  const handleSearchChange = (term: string) => {
    setSearchTerm(term);
  };

  const handleBehavioralFiltersChange = (filters: FilterState) => {
    setCurrentFilters(filters);
  };

  const handleProfileFilterChange = (value: string) => {
    setProfileFilter(value);
  };

  return {
    searchTerm,
    debouncedSearchTerm,
    isSearching,
    behavioralFiltersExpanded,
    currentFilters,
    profileFilter,
    handleSearchChange,
    setBehavioralFiltersExpanded,
    handleBehavioralFiltersChange,
    handleProfileFilterChange
  };
};
